import React from 'react'

import { ZariContext } from '_zari/context'

import { Modal, Button, Table, Form } from '_zari/core'

import { IdGen } from 'utils'

import * as AsientoContableService from 'services/asientosContables.service'

const ListaGuiasModal = ({ show, handleClose, idSocio, dispatch }) => {
  const __zariContext = React.useContext(ZariContext)

  const [filasGuias, setFilasGuias] = React.useState([])
  const [filasSeleccionadas, setFilasSeleccionadas] = React.useState([])

  React.useEffect(() => {
    AsientoContableService.obtenerGuiasPendientesxIdSocio(idSocio)
      .then(({ data }) => {
        setFilasGuias(data)
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
      })
  }, [__zariContext, idSocio])

  const clickProcesar = React.useCallback(() => {
    const matchFilas = filasGuias.filter(x => filasSeleccionadas.some(y => y === x.documento))

    const reducerPayload = matchFilas.map(x => {
      return {
        _idFila: IdGen.newId(),
        centroCostoInfo: '',
        centroCostoNivel1Info: '',
        centroCostoNivel2Info: '',
        cuentaContable: x.cuentaContable,
        cuentaContableInfo: x.cuentaContableInfo,
        cuentaDestino: '',
        cuentaDestinoInfo: '',
        esCuentaActivoFijo: false,
        flagCentroCosto: false,
        importe: parseFloat(x.montoPendiente),
        noIncluyeIgv: true,
        tipoAfectacion: '1',
        tipoMovimientoActivo: '2',
        __keyCuentaContable: IdGen.newId(),
        _idActivoFijo: '',
        _idCentroCostoNivel1: '',
        _idCentroCostoNivel2: '',
        tipoDocumento: x.tipoDocumento,
        serieDocumento: x.serieDocumento,
        numeroDocumento: x.numeroDocumento
      }
    })

    dispatch({ type: 'fill', payload: reducerPayload })
    handleClose()
  }, [filasSeleccionadas, filasGuias, dispatch, handleClose])

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title>LISTA GUIAS PENDIENTE</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table
          containerId='lista-guias-pendientes'
          filas={filasGuias}
          headRows={[
            {
              label: ''
            },
            {
              label: 'DOCUMENTO'
            },
            {
              label: 'MONTO'
            }
          ]}
          rowTemplate={(row, k) => (
            <Table.Row key={k}>
              <Table.Cell>
                <Form.Checkbox
                  checked={filasSeleccionadas.some(x => x === row.documento)}
                  id={`checkbox-${row.documento}`}
                  name={`checkbox-${row.documento}`}
                  label=''
                  onChange={() => {
                    setFilasSeleccionadas(prev => {
                      let nuevoArr = [...prev]

                      if (nuevoArr.some(x => x === row.documento)) {
                        nuevoArr = nuevoArr.filter(x => x !== row.documento)
                      } else {
                        nuevoArr.push(row.documento)
                      }

                      return nuevoArr
                    })
                  }}
                />
              </Table.Cell>
              <Table.Cell>{row.documento || '--'}</Table.Cell>
              <Table.Cell>{row.montoPendiente || '--'}</Table.Cell>
            </Table.Row>
          )}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cancelar
        </Button>
        <Button onClick={clickProcesar}>Procesar</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(ListaGuiasModal)
